import { useShouldRenderOnCurrentView } from '@hts/shared/libs';
import { IPageDepartmentSectionEntry, IPageDepartmentSectionItem } from '@hts/shared/types';
import { HtsLink } from '@hts/shared/ui';
import { memo, useCallback } from 'react';
import styles from '../../styles/Header/TopSection.module.scss';

interface TopSectionProps {
  pageDepartment: IPageDepartmentSectionEntry | null;
}

export const TopSection: React.FC<TopSectionProps> = memo(({ pageDepartment }) => {
  const shouldRender = useShouldRenderOnCurrentView(
    pageDepartment?.shouldShowOnDesktop,
    pageDepartment?.shouldShowOnMobile
  );

  const renderValue = useCallback(
    (item: IPageDepartmentSectionItem, index: number) => (
      <li key={`${item}-${index}`}>
        <HtsLink
          label={item.title}
          redirectTo={item.link}
          typographyProps={{ variant: 'subtitle', element: 'span' }}
        />
      </li>
    ),
    []
  );

  if (!pageDepartment || !pageDepartment.sectionItems.length || !shouldRender) {
    return null;
  }

  return (
    <nav className={styles.container}>
      <ul className={styles.contentContainer}>{pageDepartment.sectionItems.map(renderValue)}</ul>
    </nav>
  );
});
